import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbRespAppliedFilters } from '../SbRespAppliedFilters/SbRespAppliedFilters';
import { sbRespRefineMenuFiltersMap } from './SbRespRefineMenuFilters/sbRespRefineMenuFiltersMap';
import { SbSharedRefineMenuFilters } from '../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilters';
import { SbSharedRefineMenuDisplayPrefsSelect } from '../SbSharedRefineMenu/SbSharedRefineMenuDisplayPrefsSelect/SbSharedRefineMenuDisplayPrefsSelect';

// constants
import { VERTICALS } from '../../constants/uriConstants';

const SbRespRefineMenuComponent = ({
    viewer,
    user,
    filters,
    isClient,
    currency,
    searchBrowse,
    uriRef,
    isTrade,
}) => {
    const { isSbSharedRefineMenuDisplayPrefsSelectEnabled } = viewer;
    const { topCategoryL1 } = searchBrowse;
    const isFurniture = topCategoryL1 === VERTICALS.FURNITURE;

    return (
        <React.Fragment>
            <SbRespAppliedFilters
                user={user}
                viewer={viewer}
                currency={currency}
                searchBrowse={searchBrowse}
            />
            <SbSharedRefineMenuFilters
                user={user}
                uriRef={uriRef}
                viewer={viewer}
                filters={filters}
                currency={currency}
                isClient={isClient}
                searchBrowse={searchBrowse}
                filterMap={sbRespRefineMenuFiltersMap}
                initiallyExpanded={filterName =>
                    // FINDING-13301 expanding furniture by default in order to monitor any SEO issues
                    filterName.includes('category') || filterName.includes('price') || isFurniture
                }
                isTrade={isTrade}
            />
            {isSbSharedRefineMenuDisplayPrefsSelectEnabled && (
                <SbSharedRefineMenuDisplayPrefsSelect
                    user={user}
                    filters={filters}
                    searchBrowse={searchBrowse}
                    // FINDING-13301 expanding furniture by default in order to monitor any SEO issues
                    initiallyExpanded={isFurniture}
                />
            )}
        </React.Fragment>
    );
};

SbRespRefineMenuComponent.propTypes = {
    isClient: PropTypes.bool,
    viewer: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    user: PropTypes.object,
    uriRef: PropTypes.string.isRequired,
    isTrade: PropTypes.boolean,
};

export const SbRespRefineMenu = createFragmentContainer(SbRespRefineMenuComponent, {
    viewer: graphql`
        fragment SbRespRefineMenu_viewer on Viewer {
            ...SbRespAppliedFilters_viewer
            ...SbSharedRefineMenuFilters_viewer
            isDeliveryOptionsDisabled: isEnabledByLocale(
                featureName: "DISABLE_SB_DELIVERY_OPTION_FILTERS"
            )
            isSbSharedRefineMenuDisplayPrefsSelectEnabled: isEnabledByLocale(
                featureName: "NON_MVP_SEARCH_BROWSE"
            )
        }
    `,
    searchBrowse: graphql`
        fragment SbRespRefineMenu_searchBrowse on SearchBrowseQueryConnection {
            topCategoryL1
            ...SbRespAppliedFilters_searchBrowse
            ...SbSharedRefineMenuFilters_searchBrowse
            ...SbSharedRefineMenuDisplayPrefsSelect_searchBrowse
        }
    `,
    filters: graphql`
        fragment SbRespRefineMenu_filters on SearchBrowseFilter @relay(plural: true) {
            ...SbSharedRefineMenuFilters_filters
            ...SbSharedRefineMenuDisplayPrefsSelect_filters
        }
    `,
    user: graphql`
        fragment SbRespRefineMenu_user on User {
            ...SbRespAppliedFilters_user
            ...SbSharedRefineMenuFilters_user
            ...SbSharedRefineMenuDisplayPrefsSelect_user
        }
    `,
});
